<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template-padding analyze-page" v-else-if="loaded" > 
        
        <div class="row no-gutters mb-3 mt-3" >
            
            <div class="col-12 col-md-3" >
                
                <span class="h3 font-900 d-none" style="line-height: 34px; margin-rigth: 15px" > Group results by:  </span>
                <multiselect v-model="selectedFunnel" :options="funnels" deselect-label=" " select-label=" " track-by="name" label="name" placeholder="Select funnel:" class="d-inline-block w-100" >
                </multiselect>
                
            </div>
            <div class="col-12 col-md-5" >
                
                <span class="h3 font-900 d-none" style="line-height: 34px; margin-rigth: 15px" > Select dates:  </span>

                <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" clear-button-icon="false" :shortcuts="shortcuts" placeholder="Select dates:" ></date-picker>
                
            </div>
            
            <div class="col-12 col-md-1 text-md-right mt-2 mt-md-0" style="line-height: 34px;"  >
                                
            </div>
            
            <div class="col-12 col-md-3 text-md-right" style=""  >
                
                <!--
                Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
                -->
                <a @click="getData" class="btn btn-primary" > Request </a>
                <a @click="configureFunnels" class="btn btn-secondary" > Configure </a>
                
            </div>
            
        </div>

        
        <div class="row no-gutters mb-3 mt-3" >
            
            <div class="col-12 mt-4" v-if="funnels.length == 0" >
                
                <b-alert show variant="secondary" class="w-100 mb-3 text-center" >
                            
                    You don't have any funnels. <a @click="configureFunnels" style="text-decoration: underline" > Go to funnels </a> and create one

                </b-alert>  
                
            </div>
            
            <div class="col-12 mt-4" v-else-if="funnels.length > 0 && selectedFunnel == null" >
                
                <b-alert show variant="secondary" class="w-100 mb-3 text-center" >
                            
                    Select a funnel you want to analyze and the date range then click request.

                </b-alert>  
                
            </div>
            
            <div class="col-12 mt-5" v-if="selectedFunnel != null" >
                
                <div class="row flex-wrap-scroll" >
                    
                    <div class="col-12 col-md-4 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                        <div class="row" >
                            <div class="col-6 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                                <div> 
                                    <span class="h3 Text-color--main font-600" @click="fModalOpen( step.data )" > {{ selectedFunnel.steps[0].count }} </span>
                                    <br>
                                    <span class="graymedium-color font-600 font-size-14" > TOTAL VISITORS </span>
                                </div>
                            </div>

                            <div class="col-6 d-inline-block p-2 pl-4 pr-4" >
                                <div> 
                                    <span class="h3 Text-color--main font-600 cursor-pointer" @click="fModalOpen( selectedFunnel.orders, 'orders-wrapper' )" > {{ uniqueItemsInArray(selectedFunnel.orders, 'leadID' ) }} </span>
                                    <br>
                                    <span class="graymedium-color font-600 font-size-14" > TOTAL CUSTOMERS </span>
                                </div>
                            </div>

                            <div class="col-6 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                                <div> 
                                    <span class="h3 Text-color--main font-600 cursor-pointer" @click="fModalOpen( selectedFunnel.orders, 'orders-wrapper' )" > {{ selectedFunnel.orders.length }} </span>
                                    <br>
                                    <span class="graymedium-color font-600 font-size-14" > TOTAL ORDERS </span>
                                </div>
                            </div>

                            <div class="col-6 d-inline-block  p-2 pl-4 pr-4"  >
                                <div> 
                                    <span class="h3 Text-color--main font-600" v-if="selectedFunnel.steps[0].count > 0 && selectedFunnel.orders.length > 0" >
                                        {{ ( ( selectedFunnel.orders.length ) / ( selectedFunnel.steps[0].count ) * 100 ).toFixed(2) }} %
                                    </span>
                                    <span class="h3 Text-color--main font-600" v-if="selectedFunnel.steps[0].count == 0 && selectedFunnel.orders.length == 0" >
                                        -
                                    </span>
                                    <br>
                                    <span class="graymedium-color font-600 font-size-14" > CONVERSION RATE </span> 
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-12 col-md-4 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                       <div> 
                            <div class="font-size-20 mt-5 pt-3"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                            <div v-else-if="selectedFunnel.loaded && selectedFunnel.orders.length == 0" class="mt-5 pt-3 text-center" > No orders </div>
                            <chartBlock v-else-if="selectedFunnel.loaded && selectedFunnel.orders.length > 0" :data="selectedFunnel.orders" CHART="standard" TITLE="ORDERS" :startDate="startDate" :endDate="endDate" :HEIGHT="100" CHART_COMPONENT="full"  > </chartBlock>
                        </div>
                    </div>
                    
                    <div class="col-12 col-md-2 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                        <div> 
                            <div class="font-size-20 mt-5 pt-3"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                            <div v-else-if="selectedFunnel.loaded && selectedFunnel.sources.length == 0" class="mt-5 pt-3 text-center" > No data </div>

                            <pie-chart v-if="selectedFunnel.loaded && selectedFunnel.sources.length > 0" :chart-data="selectedFunnel.sourceChartSeries" :labels="selectedFunnel.sourceChartColumns" :height="120" symbol=" "  chartDataName="Sources" class="" ></pie-chart>

                            <!--
                            <b-progress v-else-if="selectedFunnel.loaded && selectedFunnel.sources.length > 0" :max="selectedFunnel.steps[0].count" class="d-none engagement-source-progress" height="50" >

                                <b-progress-bar v-for="(item, index) in selectedFunnel.sources" :key="index" :style="'background:#'+item.color" :label="item.name"  :value="item.engagements.length" :id="`tooltip--eng-sources-progress-`+index"  ></b-progress-bar>

                                <b-tooltip :target="`tooltip--eng-sources-progress-`+index" placement="top" triggers="hover" v-for="(item, index) in selectedFunnel.sources" :key="index+'-source'" >
                                    {{ item.name }} - {{ item.engagements.length }} <span class="ml-2" > {{ ( ( item.engagements.length * 100 ) / selectedFunnel.steps[0].count ).toFixed(2) }}% </span>
                                </b-tooltip>

                            </b-progress>
                            -->
                        </div>
                    </div>
                    
                    <div class="col-12 col-md-3 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                       <div> 
                            <div class="font-size-20 mt-5 pt-3"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                            <div v-else-if="selectedFunnel.loaded && !selectedFunnel.steps[0].data || ( selectedFunnel.steps[0].data && selectedFunnel.steps[0].data.length == 0 )" class="mt-5 pt-3 text-center" > No data </div>
                            <chartBlock v-else-if="selectedFunnel.loaded && selectedFunnel.steps[0].data.length > 0" :data="selectedFunnel.steps[0].data" CHART="standard" TITLE="VISITORS" :startDate="startDate" :endDate="endDate" :HEIGHT="100" CHART_COMPONENT="full"  > </chartBlock>
                        </div>
                    </div>
                    
                    <!--
                    <div class="col-6 col-md-2 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                        <div> 
                            <span class="h3 font-600" > {{ selectedFunnel.steps[0].count }} </span>
                            <br>
                            <span class="graymedium-color font-400 font-size-14" > TOTAL VISITORS </span>
                        </div>
                    </div>
                        
                    <div class="col-6 col-md-2 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                        <div> 
                            <span class="h3 font-600 cursor-pointer" @click="fModalOpen( selectedFunnel.orders, 'orders-wrapper' )" > {{ uniqueItemsInArray(selectedFunnel.orders, 'leadID' ) }} </span>
                            <br>
                            <span class="graymedium-color font-400 font-size-14" > TOTAL CUSTOMERS </span>
                        </div>
                    </div>
                        
                    <div class="col-6 col-md-2 d-inline-block border-right-gray p-2 pl-4 pr-4" >
                        <div> 
                            <span class="h3 font-600 cursor-pointer" @click="fModalOpen( selectedFunnel.orders, 'orders-wrapper' )" > {{ selectedFunnel.orders.length }} </span>
                            <br>
                            <span class="graymedium-color font-400 font-size-14" > TOTAL SALES </span>
                        </div>
                    </div>

                    <div class="col-6 col-md-2 d-inline-block border-right-gray  p-2 pl-4 pr-4"  >
                        <div> 
                            <span v-if="selectedFunnel.steps[0].count != 'loading'" >
                                {{ ( ( selectedFunnel.orders.length ) / ( selectedFunnel.steps[0].count ) * 100 ).toFixed(2) }} %
                            </span>
                            <br>
                            <span class="graymedium-color font-400 font-size-14" > CONVERSION RATE </span> 
                        </div>
                    </div>

                    <div class="col-6 col-md-4 d-inline-block p-2 pl-4 pr-4"  >
                        <div> 
                            <div class="font-size-20 mt-4"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                            <div v-else-if="selectedFunnel.loaded && !selectedFunnel.orders" class="mt-4" > No data </div>
                            <chartBlock v-else-if="selectedFunnel.loaded && selectedFunnel.orders" :data="selectedFunnel.orders" CHART="standard" TITLE="Orders" :startDate="startDate" :endDate="endDate" :HEIGHT="70" CHART_COMPONENT="full"  > </chartBlock>
                        </div>
                    </div>
                    -->
                    
                </div>

                <div class="w-100 mt-5 position-relative mt-3" >
                    
                    <span class="timeline-line" style="" ></span> 

                    <div class="col-12 click pr-0 font-size-14 mt-3 mb-3" v-for="(step, index) in selectedFunnel.steps"   >
                        
                        <div class="row"  >

                            <span class="timeline-bullet timeline-line-bullet" ></span>

                            <div class="col-12 "  > 

                                <div class="row ml-2 mr-2 pt-2 pb-2 border-radius bg-white" >

                                    <div class="col-12 col-md text-left pt-2" > 
                                        <span class="font-size-16 font-weight-bold" v-if="step.name" > {{ step.name }} </span>
                                        <span class="font-size-16 font-weight-bold" v-else-if="!step.name" > Step {{ index + 1 }} </span>
                                        <br>
                                        <span v-if="!step.ab_test" > {{ step.link }}  </span>
                                    </div>
                                    
                                    <div class="col-12 col-md-8 text-right" v-if="!step.ab_test" > 
                                        
                                        <div class="row " >
                                            
                                            <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right"  >
                                                <div class="mt-2" >
                                                    <h1 class="h3" > 
                                                        <span class="font-size-12" v-if="!step.goal || step.goal == ''" > No Goal set </span>
                                                        <span class="font-size-18" v-else-if="step.goal && step.goal != '' && periodDiff == null" > {{ step.goal }} </span>
                                                        <span class="font-size-18" v-else-if="step.goal && step.goal != '' && periodDiff != null" > {{ parseInt( step.goal ) * periodDiff }} </span>
                                                    </h1>
                                                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                                                        GOAL 
                                                        <font-awesome-icon :icon="['fa', 'question-circle']" :id="'tooltip--stepgoals-'+index" style="margin-top: -4px;" />  
                                                        <b-tooltip :target="'tooltip--stepgoals-'+index" placement="right" triggers="hover" custom-class="" >
                                                            <span  v-if="!step.goal || step.goal == ''" > No Goal set  </span>
                                                            <span v-else-if="step.goal && step.goal != ''" > GOAL: {{ step.goal }} {{ step.goal_type }} / day  </span>
                                                            
                                                            <div class="mt-2" > Read more on how we calculate all stats </div>
                                                        </b-tooltip>
                                                        
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" >
                                                <div class="mt-2" >
                                                    <h1 class="h3" > 
                                                        <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                        <span class="font-size-18" v-else-if="step.count == '-'" > - </span>
                                                        <span class="font-size-18 cursor-pointer" v-else-if="step.count != 'loading' && step.count != '-'" @click="fModalOpen( step.data )" > 
                                                            <span> {{ step.count }} </span> 
                                                            <!--
                                                            <span v-if="index > 0 && step.count > 0 && selectedFunnel.steps[0].count > 0" class="font-size-12 Text-color--main font-600" > CVR: {{ ( ( step.count /  selectedFunnel.steps[0].count ) * 100 ).toFixed(2) }}% </span>
-->
                                                        </span>
                                                    </h1>
                                                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > VISITORS </p>
                                                </div>
                                            </div>
                                            
                                            <!-- CONVERSION RATE -->
                                            <!-- CONVERSION RATE - traffic - for all steps except last one -->
                                            <div class="col-3 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" v-if="index < selectedFunnel.steps.length - 1 && index > 0 && selectedFunnel.steps[0].count > 0" >
                                                <div class="mt-2" >
                                                    <h1 class="h3" > 
                                                        <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                        <span class="font-size-18" v-else-if="step.count == '-'" > - </span>
                                                        <span class="font-size-18 cursor-pointer" v-else-if="step.count != 'loading' && step.count != '-'" @click="fModalOpen( step.data )" > 
                                                            <span  class=" Text-color--main font-600" > {{ ( ( step.count /  selectedFunnel.steps[0].count ) * 100 ).toFixed(2) }}% </span>
                                                        </span>
                                                    </h1>
                                                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > CONVERSION % </p>
                                                </div>
                                            </div>
                                            
                                            <!-- CONVERSION RATE - sales - for last step only -->
                                            <div class="col-3 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" v-if="index == selectedFunnel.steps.length - 1 && index > 0 && selectedFunnel.steps[0].count > 0" >
                                                <div class="mt-2" >
                                                    <h1 class="h3" > 
                                                        <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                        <span class="font-size-18" v-else-if="step.count == '-'" > - </span>
                                                        <span class="font-size-18 cursor-pointer" v-else-if="step.count != 'loading' && step.count != '-'" @click="fModalOpen( step.data )" > 
                                                            <span  class=" Text-color--main font-600" > {{ ( ( selectedFunnel.orders.length /  selectedFunnel.steps[0].count ) * 100 ).toFixed(2) }}% </span>
                                                        </span>
                                                    </h1>
                                                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > CONVERSION % </p>
                                                </div>
                                            </div>
                                            <!-- CONVERSION RATE -->
                                            
                                            <!-- EXIT RATE - for all steps except last one -->
                                            <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" v-if="index < selectedFunnel.steps.length - 1" >
                                                <div class="mt-2" >
                                                    <h1 class="h3" > 
                                                        <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                        <span class="font-size-18" v-else-if="step.count == '-'" > ? </span>
                                                        <span class="font-size-18 cursor-pointer" v-else-if="step.count != 'loading' && step.count != '-'" @click="fModalOpen( step.data )" > 
                                                            <span v-if="step.count > 0" class=" Text-color--main font-600" > 
                                                                {{  (( (( (step.count - selectedFunnel.steps[index+1].count) / step.count ) * 100).toFixed(2) >= 0 ) ? (( (step.count - selectedFunnel.steps[index+1].count) / step.count ) * 100).toFixed(2) : 100 )  }}% 
                                                            </span>
                                                            <span v-else-if="step.count == 0" class=" Text-color--main font-600" > - </span>
                                                        </span>
                                                    </h1>
                                                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > EXIT % </p>
                                                </div>
                                            </div>
                                            <!-- EXIT RATE - for all steps except last one -->
                                            
                                            <!-- SALES - for last step only -->
                                            <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" v-if="index == selectedFunnel.steps.length - 1" >
                                                <div class="mt-2" >
                                                    <h1 class="h3" > 
                                                        <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                        <span class="font-size-18 cursor-pointer"  @click="fModalOpen( selectedFunnel.orders, 'orders-wrapper' )" > 
                                                            <span class=" Text-color--main font-600" > {{ selectedFunnel.orders.length }} / {{ uniqueItemsInArray(selectedFunnel.orders, 'leadID' ) }} </span>
                                                        </span>
                                                    </h1>
                                                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > ORDERS / CUSTOMERS </p>
                                                </div>
                                            </div>
                                            <!-- SALES - for last step only -->
                                            
                                            
                                            
                                            <!-- TRAFFIC CHART - for all steps except last one -->
                                            <div class="col-12 col-md-4 pr-3 pl-3 text-center" v-if="index < selectedFunnel.steps.length - 1" >
                                                <!-- CHART -->
                                                <div class="font-size-20 mt-4"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                                                <div v-else-if="selectedFunnel.loaded && !step.data" class="mt-4" > No data </div>
                                                <chartBlock v-else-if="selectedFunnel.loaded && step.data" :data="step.data" CHART="standard" :startDate="startDate" :endDate="endDate" :HEIGHT="70" CHART_COMPONENT="full"  > </chartBlock>
                                                <!-- CHART -->
                                            </div>
                                            <!-- TRAFFIC CHART - for all steps except last one -->
                                            
                                            <!-- SALES - for last step only -->
                                            <div class="col-12 col-md-4 pr-3 pl-3 text-center" v-if="index == selectedFunnel.steps.length - 1" >
                                                <!-- CHART -->
                                                <div class="font-size-20 mt-4"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                                                <div v-else-if="selectedFunnel.loaded && selectedFunnel.orders.length == 0" class="mt-4" > No orders </div>
                                                <chartBlock v-else-if="selectedFunnel.loaded && selectedFunnel.orders.length > 0" :data="selectedFunnel.orders" CHART="standard" :startDate="startDate" :endDate="endDate" :HEIGHT="70" CHART_COMPONENT="full"  > </chartBlock>
                                                <!-- CHART -->
                                            </div>
                                            <!-- SALES - for last step only -->
                                            
                                        </div> <!-- .row -->
                                        
                                    </div>

                                    <!-- AB TEST -->
                                    <div class="col-12 col-md-11 offset-md-1 text-left" v-if="step.ab_test" >
                                        
                                        <div class="row mt-4 mb-3" v-if="step.links" v-for="(link, i) in step.links" >
                                                
                                            <!-- AB TEST LINK -->
                                            <div class="row w-100" >
                                            
                                                    <div class="col-12 col-md-3 text-left pt-2" > 
                                                        <span  > {{ link.link }}  </span>
                                                    </div>
                                                
                                                    <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right"  >
                                                        <div class="mt-2" >
                                                            <h1 class="h3" > 
                                                                <span class="font-size-12" v-if="!step.goal || step.goal == ''" > No Goal set </span>
                                                                <span class="font-size-18" v-else-if="step.goal && step.goal != '' && periodDiff == null" > {{ step.goal }} </span>
                                                                <span class="font-size-18" v-else-if="step.goal && step.goal != '' && periodDiff != null" > {{ parseInt( step.goal ) * periodDiff }} </span>
                                                            </h1>
                                                            <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                                                                GOAL 
                                                                <font-awesome-icon :icon="['fa', 'question-circle']" :id="'tooltip--stepgoals-'+index" style="margin-top: -4px;" />  
                                                                <b-tooltip :target="'tooltip--stepgoals-'+index" placement="right" triggers="hover" custom-class="" >
                                                                    <span  v-if="!step.goal || step.goal == ''" > No Goal set  </span>
                                                                    <span v-else-if="step.goal && step.goal != ''" > GOAL: {{ step.goal }} {{ step.goal_type }} / day  </span>

                                                                    <div class="mt-2" > Read more on how we calculate all stats </div>
                                                                </b-tooltip>

                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" >
                                                        <div class="mt-2" >
                                                            <h1 class="h3" > 
                                                                <span class="font-size-18" v-if="link.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                                <span class="font-size-18" v-else-if="link.count == '-'" > - </span>
                                                                <span class="font-size-18 cursor-pointer" v-else-if="link.count != 'loading' && link.count != '-'" @click="fModalOpen( link.data )" > 
                                                                    <span> {{ link.count }} </span> 
                                                                </span>
                                                            </h1>
                                                            <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > VISITORS </p>
                                                        </div>
                                                    </div>

                                                    <!-- CONVERSION RATE -->
                                                    <!-- CONVERSION RATE - traffic - for all steps except last one -->
                                                    <!--
                                                    <div class="col-3 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" v-if="index < selectedFunnel.steps.length - 1 && index > 0 && selectedFunnel.steps[0].count > 0" >
                                                        <div class="mt-2" >
                                                            <h1 class="h3" > 
                                                                <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                                <span class="font-size-18" v-else-if="step.count == '-'" > - </span>
                                                                <span class="font-size-18 cursor-pointer" v-else-if="step.count != 'loading' && step.count != '-'" @click="fModalOpen( step.data )" > 
                                                                    <span  class=" Text-color--main font-600" > {{ ( ( step.count /  selectedFunnel.steps[0].count ) * 100 ).toFixed(2) }}% </span>
                                                                </span>
                                                            </h1>
                                                            <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > CONVERSION % </p>
                                                        </div>
                                                    </div>
                                                    -->

                                                    <!-- EXIT RATE - for all steps except last one -->
                                                    <div class="col-4 col-md-2 pt-2 pr-3 pl-3 border-right-gray text-right" v-if="index < selectedFunnel.steps.length - 1" >
                                                        <div class="mt-2" >
                                                            <h1 class="h3" > 
                                                                <span class="font-size-18" v-if="step.count == 'loading'" > <spinner type="xsmall" ></spinner> </span>
                                                                <span class="font-size-18" v-else-if="step.count == '-'" > ? </span>
                                                                <span class="font-size-18 cursor-pointer" v-else-if="step.count != 'loading' && step.count != '-'" @click="fModalOpen( link.data )" > 
                                                                    <span v-if="link.count > 0" class=" Text-color--main font-600" > 
                                                                        {{  (( (( (link.count - selectedFunnel.steps[index+1].count) / link.count ) * 100).toFixed(2) >= 0 ) ? (( (link.count - selectedFunnel.steps[index+1].count) / link.count ) * 100).toFixed(2) : 100 )  }}% 
                                                                    </span>
                                                                    <span v-else-if="link.count == 0" class=" Text-color--main font-600" > - </span>
                                                                </span>
                                                            </h1>
                                                            <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > EXIT % </p>
                                                        </div>
                                                    </div>
                                                    <!-- EXIT RATE - for all steps except last one -->

                                                    <!-- TRAFFIC CHART - for all steps except last one -->
                                                    <div class="col-12 col-md-3 pr-3 pl-3 text-center"  >
                                                        <div class="font-size-20 mt-4"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </div>
                                                        <div v-else-if="selectedFunnel.loaded && ( !link.data || link.data.length == 0 )" class="mt-4" > No data </div>
                                                        <chartBlock v-else-if="selectedFunnel.loaded && link.data" :data="link.data" CHART="standard" :startDate="startDate" :endDate="endDate" :HEIGHT="70" CHART_COMPONENT="full"  > </chartBlock>
                                                    </div>
                                                    <!-- TRAFFIC CHART - for all steps except last one -->

                                                </div> <!-- .row -->
                                            <!-- AB TEST LINK -->
                                        </div>
                                        
                                    </div>
                                    <!-- AB TEST -->
                                    
                                </div>

                            </div>

                        </div>
                        
                    </div>
                
                    <!-- FUNNEL CONVERSION -->
                    <div class="col-12 click font-size-14 mt-3 mb-3 d-none" v-if="selectedFunnel.conversions.length > 0"  >

                        <div class="row "  >

                            <span class="timeline-bullet timeline-line-bullet" ></span>

                            <div class="col-12 " > 

                                <div class="row ml-2 mr-2 pt-2 pb-2 border-gray border-radius bg-white" >

                                    <div class="col text-left" > 
                                        <span class="font-size-16 font-weight-bold" > CONVERSIONS </span>
                                        <br>
                                    </div>
                                    <div class="col-auto text-right" > 
                                        <span class="" style="line-height: 52px;" > 
                                            <span class="font-size-20"  v-if="!selectedFunnel.loaded" > <spinner type="xsmall" ></spinner> </span>
                                            <span class="font-size-20 cursor-pointer" v-else-if="selectedFunnel.loaded" @click="fModalOpen( selectedFunnel.orders, 'orders-wrapper' )" > 
                                                <span> {{ selectedFunnel.orders.length }}  </span> 
                                                <span class="Text-color--main border-left-gray pl-2 ml-2" > 
                                                    <span class="font-size-12 font-500 " > CVR:  </span> 
                                                    <span v-if="selectedFunnel.orders.length > 0 && selectedFunnel.steps[0].count > 0" > {{ ( ( selectedFunnel.orders.length /  selectedFunnel.steps[0].count ) * 100 ).toFixed(1) }}%   </span>
                                                    <span v-else="" > - </span>
                                                </span>
                                            </span>
                                        </span> 
                                    </div>
                                    <div class="col-1 text-center" > 
                                        <span class="font-size-20" style="line-height: 52px;font-size: 20px;" > 
                                            <font-awesome-icon @click="fModalOpen( step.data )"  class="font-size-13 cursor-pointer" :icon="['fas', 'arrow-alt-circle-right']" />
                                        </span>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <!-- FUNNEL CONVERSION -->
                    
                </div>
                
            </div>

        </div>
        
        <modal :modalData="modalData" :modalState="modalState" :modalComponent="modalComponent" ></modal>
        
    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
    
import helper from '@/helpers/helpers.js';
import modal from '@/components/modal.vue'    
import lineChart from '@/components/charts/lineChart_full.js'   
import chartBlock from '@/components/chartBlockNaked'   
import pieChart from '@/components/charts/pieChart.js'    
    
export default{
    name: "organizations",
    components:{
        modal,
        lineChart,
        chartBlock,
        pieChart
    },
    data () {
        return {
            loaded : false,
            filter: '',
            rows: [],
            
            dataLoaded: false,
            modalData: null,
            modalState: false,
            modalComponent: null,
            
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            periodDiff : null,
            shortcuts: [
                { 
                    text: 'Today', 
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('day').toDate();
                        let end = this.$moment(Date.now()).endOf('day').toDate();

                        let period = [ start, end ];
                        //console.log(period)
                        return period;
                    } 
                },
                {
                    text: 'Yesterday',
                    onClick: () => {
                        //console.log( Date.now() )
                        //let start = this.$moment( ).subtract(1,'d').format( "YYYY-MM-DD 00:00:00" )
                        //let end = this.$moment( ).subtract(1,'d').endOf('day').format( "YYYY-MM-DD 00:00:00" )
                        
                        let start = this.$moment( ).subtract(1,'d').toDate();
                        let end = this.$moment( ).subtract(1,'d').endOf('day').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 7 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(7,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'weeks').startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'weeks').endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('month').toDate();
                        let end = this.$moment(Date.now()).endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 30 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(30,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'months').startOf('month').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'months').endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 3 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(3,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 6 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(6,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
            ],
            
            sales:[],
            funnels:[],
            selectedFunnel: null,

        }
    },
    beforeCreate: function (){
    
    },
    mounted: function(){
        
        //this.loaded = true;
        this.getFunnels()

    },
    computed: {
    },
    methods: {
        
        init_period(){
            
            let end = this.$moment(Date.now()).format('D MMM YYYY');
            //let start = this.$moment(Date.now()).subtract(30,'d').format('D MMM YYYY');
            let start = this.$moment(Date.now()).startOf('day').format('D MMM YYYY');

            this.period = [ start, end ];
            
            //this.get_data()
            this.getData()
            
        },
        
        getFunnels(){
            
            let OrgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+OrgID+'/funnels').orderBy('datetime', 'desc')
            
            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                            let item = {};                
                            item = doc.data(); // will have 'todo.title'
                            item.id = doc.id;
                            //console.log(item)
                            item.steps.forEach((step)=>{
                                step.count = 0
                                step.color = "#"+Math.floor(Math.random()*16777215).toString(16);
                            })
                            item.loaded = true
                            item.orders = []    
                            item.sources = []    

                            results.push(item);     
                            //console.log( item )

                            //results.sort((a, b) => b.datetime - a.datetime);

                            this.funnels = results

                            return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
         
        getSales(){
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
                        
            this.selectedFunnel.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let timezone = helper.getAccountTimezone()   
            let startUnix = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix()
            let endUnix = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).unix()
            
            this.startDate = startUnix
            this.endDate = endUnix
            
            //console.log( this.startDate + " " + this.endDate )
            
            let periodDiff = (( endUnix - startUnix ) / ( 60*60*24 )).toFixed(0)
            if( endUnix > moment().tz("UTC").unix() ){
                periodDiff = (( moment().tz("UTC").unix() - startUnix ) / ( 60*60*24 )).toFixed(0)
            }
            this.periodDiff = periodDiff
            
            //console.log(this.selectedFunnel)
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                //url: process.env.ROOT_API+'/analyze/sales-new', 
                url: 'https://sql.theatlass.com/api-v2/analyze/sales.php', 
                headers: headers, 
                data: { 
                    "APPKEY": orgID,
                    "startDate":  startUnix,
                    "endDate":  endUnix,
                    //"orderTags": this.selectedFunnel.conversions[0] //not finished
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){

                    let sales = resp.data.data;
                    this.sales = sales
                    
                    if( this.selectedFunnel != null ){
                            
                        let APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                        let funnel = this.selectedFunnel
                        let f = helper.getFunnelData( APPKEY, this.sales, this.period, funnel )   

                        //console.log(f)
                        this.selectedFunnel = f

                        this.dataLoaded = false

                    }
                    
                }else{
                    console.log(resp)
                }                
                
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        getSales_FB(){
            
            this.selectedFunnel.loaded = false
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let timezone = helper.getAccountTimezone()   
            let startUnix = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix()
            let endUnix = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).unix()
            
            this.startDate = startUnix
            this.endDate = endUnix
            
            //console.log( this.startDate + " " + this.endDate )
            
            let periodDiff = (( endUnix - startUnix ) / ( 60*60*24 )).toFixed(0)
            if( endUnix > moment().tz("UTC").unix() ){
                periodDiff = (( moment().tz("UTC").unix() - startUnix ) / ( 60*60*24 )).toFixed(0)
            }
            this.periodDiff = periodDiff

            var ref = firebase.firestore().collection('organizations/'+orgID+'/orders').where('datetime', '>=', startUnix).where( 'datetime', '<=', endUnix ).orderBy('datetime', 'asc')

            ref.get()
            .then((snapshot) => {
                if( !snapshot.empty ){
                    let results = []
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                
                                results.push(item)

                                this.sales = results
                                return results; 

                        })

                    )
                    .then(results => {
                        
                        if( this.selectedFunnel != null ){
                            
                            let APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                            let funnel = this.selectedFunnel
                            let f = helper.getFunnelData( APPKEY, this.sales, this.period, funnel )   
                            
                            //console.log(f)
                            this.selectedFunnel = f
                            
                            this.dataLoaded = false
                            
                        }
                        
                        return results;   

                    })
                }else{
                    //console.log("no orders")
                }
            })

        },
        
        getData(){
            
            if( this.selectedFunnel == null || ( this.period[0] == "" && this.period[1] == "" ) ){
                
                this.$toast.warn({
                    title: 'Couldn`t fetch data',
                    message:  'Please make sure to select the funnel and a date range'
                })
                
            }else{
                this.getSales()
            }
            
        },
        
        
        getData_old(){
            
            if( this.selectedFunnel == null || ( this.period[0] == "" && this.period[1] == "" ) ){
                
                this.$toast.warn({
                    title: 'Couldn`t fetch data',
                    message:  'Please make sure to select the funnel and a date range'
                })
                
            }else{
                
                //GET CONVERSIONS
                let funnel = this.selectedFunnel
                //console.log( this.selectedFunnel.conversions )
                //console.log( funnel.conversions.length )
                if( funnel.conversions.length > 0 ){
                    
                    let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )

                    let startUnix = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix()
                    let endUnix = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).unix()

                    var ref = firebase.firestore().collection('organizations/'+orgID+'/orders').where('datetime', '>=', startUnix).where( 'datetime', '<=', endUnix ).orderBy('datetime', 'asc')

                    ref.get()
                    .then((snapshot) => {
                        if( !snapshot.empty ){
                            let results = []
                            return Promise.all(
                                snapshot.docs.map(doc => {  
                                        let item = {};                
                                        item = doc.data(); // will have 'todo.title'
                                        item.id = doc.id;
                                
                                        this.selectedFunnel.conversions.forEach((tag)=>{
                                            if( item.tag == tag ){
                                                this.selectedFunnel.orders.push( item )
                                                results.push(item); 
                                            }else{
                                                item.orderItems.forEach((orderItem)=>{
                                                    if( tag == orderItem.tag ){
                                                        this.selectedFunnel.orders.push( item )
                                                        //results.push(item); 
                                                    }
                                                })
                                            }
                                        })

                                        //this.rows = results
                                        return results; 

                                })

                            )
                            .then(results => {           

                                //console.log( results )
                                //console.log( this.selectedFunnel.orders )
                                //this.filterTags = this.filterTags.filter((elem, index, self) => self.findIndex( (t) => {return (t.value === elem.value )}) === index)
                                return results;   

                            })
                        }else{
                            //console.log("no orders")
                        }
                    })
                        
                }
                
                ////////////////////////////////////////////////////////////////
                
                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }

                let timezone = helper.getAccountTimezone()            
                let start = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                let end = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                let offset = moment.tz(this.period[0], timezone ).format('Z')

                let signup = helper.getAccountSettings().datetime
                if( moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix() < signup ){
                    //console.log( "Cannot request data for date prior to sign up" );
                    start = moment.unix( signup ).tz("UTC").format( 'YYYY-MM-DD HH:mm:ss' )
                }

                //console.log(this.selectedFunnel)
                
                this.selectedFunnel.steps.forEach((step)=>{
                    
                    let searchPhrase = step.link
                    let funnel = this.selectedFunnel
                    
                    //step.count = 'loading'

                    return axios({ 
                        method: 'post',
                        //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                        url: 'https://sql.theatlass.com/api-v2/getList.php?s='+searchPhrase,
                        headers: { 
                            'Access-Control-Allow-Headers': '*', 
                            'Access-Control-Allow-Origin': '*',  
                            'Content-Type': 'application/json;' 
                        },
                        async: true,
                        data: { 
                            "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                            //"startDate":  moment.utc(this.period[0]).format('YYYY-MM-DD'),
                            "startDate":  start,
                            //"endDate":  moment.utc(this.period[1]).add(1, 'day').format('YYYY-MM-DD'),
                            "endDate":  end,
                            "tz_to": offset,
                            "searchPhrase": searchPhrase,
                            //"filters":  { key: "email", operator: "!=", value: "" }
                        } 
                    })
                    .then(resp => {
                        //console.log(resp)
                        if( resp.status == 200 ){
                            let response_data = resp.data.data.results

                            //version 2 with list
                            step.data = response_data
                            step.count = step.data.length

                        }else{
                            //console.log("")
                        }                
                    })
                    .then(function(){

                        step.loaded = true
                        //console.log( funnel.name + " - " + index + " - " + searchPhrase )

                        let all_loaded = []
                        let isReady = funnel.steps.every(data=> data.loaded)
                        //console.log(isReady)
                        if( isReady ){ 
                            funnel.steps.forEach((step, index)=>{

                                if( index > 0 ){
                                    let curated = []
                                    
                                    //console.log(step.link)
                                    
                                    step.data.forEach((visitor)=>{
                                        
                                        //CHECK IF VISITOR IS PRESENT IN PREVIOUS STEP
                                        //FAULTY
                                        /*
                                        funnel.steps.forEach((previousStep, previousIndex)=>{
                                            if( previousIndex < index && previousStep.data.length > 0 ){
                                                previousStep.data.forEach((previousVisitor)=>{
                                                    if( visitor.leadID == previousVisitor.leadID && curated.find(el => el.leadID === visitor.leadID ) == undefined ){
                                                        //console.log(  visitor.sourceTag + " vs "+ previousVisitor.sourceTag )
                                                        if( visitor.sourceTag == null && previousVisitor.sourceTag != null ){
                                                            visitor.sourceTag = previousVisitor.sourceTag
                                                            visitor.sourceName = previousVisitor.sourceName
                                                        }
                                                        //console.log( visitor )
                                                        curated.push( visitor )
                                                    }
                                                })
                                            }
                                            
                                        })
                                        */
                                        
                                        //console.log( visitor.email + " - " + funnel.steps[0].data.find(el => el.leadID === visitor.leadID ) )
                                        
                                        //CHECK IF VISITOR IS PRESENT IN ANY STEP
                                        let found = false
                                        funnel.steps.forEach((previousStep, previousIndex)=>{
                                            previousStep.data.forEach((previousVisitor)=>{
                                                if( visitor.leadID == previousVisitor.leadID && curated.find(el => el.leadID === visitor.leadID ) == undefined ){
                                                    //console.log(  visitor.sourceTag + " vs "+ previousVisitor.sourceTag )
                                                    if( visitor.sourceTag == null && previousVisitor.sourceTag != null ){
                                                        visitor.sourceTag = previousVisitor.sourceTag
                                                        visitor.sourceName = previousVisitor.sourceName
                                                    }
                                                    //console.log( visitor )
                                                    //curated.push( visitor )
                                                }
                                            })
                                            
                                            if( step.link != previousStep.link ){
                                                if( previousStep.data.find(el => el.leadID === visitor.leadID ) != undefined ){
                                                    found = true
                                                }
                                            }
                                            
                                            
                                        })
                                        
                                        if( found  ){
                                            curated.push( visitor )
                                        }
                                        
                                    })
                                    //step.data = curated 
                                    step.count = step.data.length
                                    
                                    //console.log(step.data)
                                    
                                    let groupped = helper.groupSalesBy( step.data, start, end )
                                    //console.log( groupped )
                                    
                                }

                            })
                            
                            let curatedOrders = []
                            funnel.orders.forEach((order)=>{
                                if( funnel.steps[0].data.find(el => el.leadID === order.leadID ) != undefined  ){
                                    //console.log( order )
                                    curatedOrders.push( order )
                                }
                            })
                            //funnel.orders = curatedOrders
                            
                            funnel.loaded = true 
                        }


                    }.bind(this))
                    .catch(error => {

                        //console.log(error)
                        this.$toast.error({
                            title:'Error',
                            message:  'Error while fetching data. Please reach out to us!'
                        })

                    }); //end axios 
                    //AXIOS  
                    
                })
                
                //console.log(this.selectedFunnel)
                //console.log(this.selectedFunnel.orders.length)
                this.loaded = true;
                
                ////////////////////////////////////////////////////////////////
                
            }
                
            
        },

        fModalOpen( data, component = 'engagement' ){
            
            //console.log(data)
            //console.log(component)
            
            this.modalData = data
            this.modalComponent = component
            this.modalState = true
        },
        
        refresh_chart( $event ){
            
            //console.log($event)
            this.rows = []
            if( this.period[0] == null || this.period[1] == null ){
                this.init_period()
            }else{
                
                this.getData()

            }
            
        },
        
        uniqueItemsInArray(data, identifier ){
            return helper.uniqueItems( data, identifier )
        },
        
        configureFunnels(){
            
            this.modalState = true;
            this.modalComponent = "funnels"
            this.modalData = this.funnels
            
        },
        
        randomColor( index ){
            
            let color = Math.floor(Math.random()*16777215).toString(16);
            //console.log(color)
            return "#" + color
            
        }
        
    },
    watch:{

    },
    computed:{
  
    },
}
</script>


<style lang="scss" >
    
    .tab-content{
        
    }
    
    .card-body{
        padding-left:0;
        padding-right:0;
    }

</style>


// WEBPACK FOOTER //
// src/templates/analyze/FunnelAnalysis.vue